import { Component, OnInit, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-staff-playground-assign-modal',
    templateUrl: './staffPlaygroundAssignModal.component.html',
    styleUrls: ['./staffPlaygroundAssignModal.component.scss']
})
export class StaffPlaygroundAssignModalComponent implements OnInit {  
    
    public data: any;
    public selectedStaff: any;

    constructor(private instance: NgbActiveModal) { }

    ngOnInit() {

    }

    public Cancel(reason: any) {
        this.instance.dismiss(reason);
    }

    public Save() {
        this.instance.close(this.selectedStaff);
    }

    public selectStaff(staff) {
        this.selectedStaff = staff;
    }

    private GetModalContainer() {
        return '.fm-ng-wrapper';
    }
}

